import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=75372dae"
import script from "./LocaleChanger.vue?vue&type=script&lang=js"
export * from "./LocaleChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75372dae')) {
      api.createRecord('75372dae', component.options)
    } else {
      api.reload('75372dae', component.options)
    }
    module.hot.accept("./LocaleChanger.vue?vue&type=template&id=75372dae", function () {
      api.rerender('75372dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/LocaleChanger.vue"
export default component.exports